import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "resetView",
  "use": "resetView-usage",
  "viewBox": "0 0 55 55",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 55 55\" id=\"resetView\"><title>资源 3</title><g data-name=\"图层 2\"><path d=\"M27.5 5.11a25.85 25.85 0 0 1 12.18 3.53l-5.11 7.86L55 26.71A27.42 27.42 0 0 0 27.5 0C15.71 0 5.11 8.25 1.57 18.86a2.74 2.74 0 1 0 5.11 2C10.21 13 18.46 5.11 27.5 5.11zm0 44.79c8.64 0 17.68-5.89 20.43-13.75 1.57-5.11 6.68-2.75 5.5.39A27.48 27.48 0 0 1 0 28.29l20 11.39-4.32 6.68a23.12 23.12 0 0 0 11.82 3.53zm0-15.32a7.07 7.07 0 1 1 7.07-7.07 7 7 0 0 1-7.07 7.06z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/resetView.svg
// module id = i4nH
// module chunks = 6